// @ts-check
import { useSelector } from 'react-redux';

import { useHasRefundAssistVoidedShipments } from './use-is-refund-assist-visible';
import { VOID_TYPE } from '../../filters/constants';
import Global from '../../store/global-selectors';
import { selectShipmentsGridCurrentPageFulfillmentIds } from '../../store/shipments/grid/shipments.grid.selectors';
import { useIsRefundAssistEnabled } from '../use-seller-setting';

/**
 * Hook to determine if void type column/filter should be shown
 * Checks three conditions:
 * 1. User has Refund Assist grid visibility (permissions + feature enabled)
 * 2. Current page has any Refund Assist voided shipments
 * 3. Void type filter is actively applied
 * @returns {boolean} True if void type should be shown
 */
export const useShouldShowVoidType = () => {
  const isRefundAssistEnabled = useIsRefundAssistEnabled();
  const currentPageFulfillmentPlanIds = useSelector(selectShipmentsGridCurrentPageFulfillmentIds);
  const hasRefundAssistVoidedShipments = useHasRefundAssistVoidedShipments(currentPageFulfillmentPlanIds);
  const activeFilterView = useSelector(Global.selectShipmentsFilteringActiveFilterView);
  const hasVoidTypeFilter = activeFilterView?.appliedFilters?.some(
    (/** @type {{ filterById: string; }} */ f) => f.filterById === VOID_TYPE,
  );

  // Show void type if ANY of these conditions are true:
  // - User has RA permissions and feature enabled
  // - Current page has RA voided shipments
  // - User has actively applied a void type filter
  return isRefundAssistEnabled || hasRefundAssistVoidedShipments || hasVoidTypeFilter;
};
